module.exports = __webpack_public_path__ + "lu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/lu.svg
// module id = 670
// module chunks = 0